import formBaseMixin  from '../../../components/form/form-base-mixin.js'
import {
  GARBAGE_TYPE_COUNTRY_COMM,
  GARBAGE_TYPE_MANAGER,
  GARBAGE_TYPE_SETTLEMENT,
  STATUS_NOT_ACTIVE
}                     from '@/config/config'
import documentsMixin from '@/common/layout/documents/documentsMixin'

export default {
  mixins: [formBaseMixin, documentsMixin],
  data() {
    return {
      tabView: 'tab1',
      fields:  {
        documents: [],
        garbage_source_id:         '',
        tko_operator_id:           '',
        garbage_source:            {},
        tko_operator:              {},
        msn_id:                    [],
        tko_operator_transport_id: [],
        _tkoOperatorName:          '',
        _garbageSourceName:        ''
      }
    }
  },
  computed: {
    formTitle() {
      if (this.fields && this.fields.id) {
        return this.fields.number
      }
      return this.$translate('Добавление новой записи')
    },
    acceptViewSourcesTab() {
      if (this.fields.garbage_source && this.fields.garbage_source.garbage_source_type_id) {
        if ([
          GARBAGE_TYPE_MANAGER,
          GARBAGE_TYPE_COUNTRY_COMM,
          GARBAGE_TYPE_SETTLEMENT
        ].indexOf(+this.fields.garbage_source.garbage_source_type_id) > -1) {
          return true
        }
      }
      return false
    },
    notActive() {
      return STATUS_NOT_ACTIVE
    }
  },
  methods:  {
    innerUpdated() {
      if (this.fields.id) {
        this.onlyUpdate = true
        this.sendForm()
      }
    },
    onSuccess(response, afterSaveResponse) {
      if (this.fields.id) {
        this.showOnSuccess('Данные обновлены')
      } else {
        this.showOnSuccess('Запись сохранена')
      }
      this.unFreezeFrom()
      this.onSaveForm()
      if (this.onlyUpdate === true) {
        this.onlyUpdate = false
      } else {
        setTimeout(() => {
          this.$router.push(this.getRedirectParams())
        }, 0)
      }
    },
    initFieldsAfterLoad() {
      if (this.item) {
        this.fields = Object.assign({}, this.item)
        if (this.item.garbage_source) {
          this.fields.garbage_source_id  = this.item.garbage_source.id
          this.fields._garbageSourceName = this.item.garbage_source.name
          if (this.item.garbage_source_type) {
            this.fields.garbage_source.type = this.item.garbage_source_type.name
          }
        }
        if (this.item.tko_operator) {
          this.fields.tko_operator_id  = this.item.tko_operator.id
          this.fields._tkoOperatorName = this.item.tko_operator.name
        }
      }
    },
    cleanAndUpdateAllRelatedToTKOOperator() {
      this.$set(this.fields, 'tko_operator_transport_id', [])
      this.$refs.contractTransports.updateDataInInnerTable()
    },
    onSelectOperator($event) {
      if ($event && $event.id) {
        let copy = JSON.parse(JSON.stringify($event))
        if (this.fields.tko_operator_id != copy.id) {
          this.cleanAndUpdateAllRelatedToTKOOperator()
        }
        this.fields.tko_operator_id  = copy.id
        this.fields._tkoOperatorName = this.$options.filters.stripHtml(
          copy.name
        )
        this.fields.tko_operator     = Object.assign({}, copy)
      } else {
        this.cleanAndUpdateAllRelatedToTKOOperator()
        this.fields.tko_operator_id  = ''
        this.fields._tkoOperatorName = ''
        this.fields.tko_operator     = Object.create({})
      }
    },
    cleanAndUpdateAllRelatedToGarbageSource() {
      this.$set(this.fields, 'msn_id', [])
      this.$refs.contractMsns.updateDataInInnerTable()
    },
    selectGarbageSource($event) {
      if ($event && $event.id) {
        let copy = JSON.parse(JSON.stringify($event))
        if (this.fields.garbage_source_id != copy.id) {
          this.cleanAndUpdateAllRelatedToGarbageSource()
        }
        this.fields.garbage_source_id  = copy.id
        this.fields._garbageSourceName = this.$options.filters.stripHtml(
          copy.name
        )
        this.fields.garbage_source     = Object.assign({}, copy)
      } else {
        this.cleanAndUpdateAllRelatedToGarbageSource()
        this.fields.garbage_source_id  = ''
        this.fields._garbageSourceName = ''
        this.fields.garbage_source     = Object.create({})
      }
    },
    transformSuggestions(ctx, data) {
      return data.data
    }
  },
  asyncData({ store, route, fromRoute, methods }) {
    let promises = []
    if (methods.getItemEndpoint(route, fromRoute) !== null) {
      promises.push(store.dispatch('updateUrlEndpoint', { endpoint: methods.getItemEndpoint(route, fromRoute) }))
    }
    
    if (promises.length === 0) {
      return Promise.resolve(1)
    }
    
    return Promise.all(promises)
  }
}

